export const Info = (
  <div>
    <p className="text-sm sm:text-lg">
      Hello! I am Michael, an aspiring trainee hoping to become an ethical
      hacker in the future.
    </p>
    <br />
    <p className="text-sm sm:text-lg">
      Currently I'm a security analyst doing a traineeship at {" "}
      <span className="cc-3">Wortell Enterprise Security</span>. I
      convert coffee and dreams into code and reality and hope that one day I’ll
      understand malware as if it were my child. When I'm not coding, studying
      or designing you'll find me expanding my knowledge, trying out new things
      or working out.
    </p>
  </div>
);

export default Info;
